import { render, staticRenderFns } from "./Waste-1Report.vue?vue&type=template&id=25dddf9a&scoped=true"
import script from "./Waste-1Report.vue?vue&type=script&lang=js"
export * from "./Waste-1Report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dddf9a",
  null
  
)

export default component.exports